"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithSession = exports.withSession = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const SessionContext_1 = require("../contexts/SessionContext");
const errors_1 = require("../errors");
const withSession = (Component, displayName) => {
    displayName = displayName || Component.displayName || Component.name || 'Component';
    Component.displayName = displayName;
    const HOC = (props) => {
        const session = (0, SessionContext_1.useSessionContext)();
        if (!session) {
            return null;
        }
        return (react_1.default.createElement(Component, Object.assign({}, props, { session: session })));
    };
    HOC.displayName = `withSession(${displayName})`;
    return HOC;
};
exports.withSession = withSession;
const WithSession = ({ children }) => {
    const session = (0, SessionContext_1.useSessionContext)();
    if (typeof children !== 'function') {
        throw new Error(errors_1.hocChildrenNotAFunctionError);
    }
    if (!session) {
        return null;
    }
    return react_1.default.createElement(react_1.default.Fragment, null, children(session));
};
exports.WithSession = WithSession;
